
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/[social]/[providerUserToken]",
      function () {
        return require("private-next-pages/auth/[social]/[providerUserToken].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/[social]/[providerUserToken]"])
      });
    }
  